export default __webpack_public_path__ + "static/media/elipse_teachers.b0e22913.svg";